var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-chart',{attrs:{"chartType":_vm.chartType,"chartData":_vm.chartData,"chartConfig":_vm.chartConfig,"chartSettings":_vm.chartSettings,"chartExtend":_vm.chartExtend,"loading":_vm.loading,"emptyContent":_vm.emptyContent,"showToolbox":_vm.showToolbox,"extraToolbox":_vm.extraToolbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }